type CourseIframeEntry = {
  keyword: string;
  iframeUrl: string;
};

export const COURSE_IFRAME_CONFIG: CourseIframeEntry[] = [
  {
    keyword: 'python',
    iframeUrl: 'https://dilan2.github.io/lit_docker_quiz_test/quiz-python-full.html',
  },
  {
    keyword: 'devops',
    iframeUrl: 'https://dilan2.github.io/lit_docker_quiz_test/quiz-devops-full.html',
  },
  { keyword: 'data science', iframeUrl: 'https://example.com/ds-test' },
];

export const getIframeUrlForCourse = (courseName: string): string | null => {
  const entry = COURSE_IFRAME_CONFIG.find((e) =>
    courseName.toLowerCase().includes(e.keyword.toLowerCase()),
  );
  return entry?.iframeUrl ?? null;
};
